export default "__VITE_ASSET__15130886__"